import React from 'react';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { Benefits } from './components/Benefits';
import { ForWho } from './components/ForWho';
import { Testimonials } from './components/Testimonials';
import { Sponsors } from './components/Sponsors';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-brand-bg font-body text-brand-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <TrustBar data-id="element-2" />
      <Sponsors data-id="element-3" />
      <Problem data-id="element-4" />
      <Solution data-id="element-5" />
      <Modules data-id="element-6" />
      <Benefits data-id="element-7" />
      <ForWho data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Sponsors data-id="element-10" />
      <ValueStack data-id="element-11" />
      <Guarantee data-id="element-12" />
      <Urgency data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <FAQ data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}